import { createAsyncThunk } from '@reduxjs/toolkit';
import { Connection } from '../../../../model/types/positionsConnectionsSliceSchema';
import { RootState } from '../../../../../../store';
import { positionsConnectionsActions } from '../positionsConnectionsSlice';
import { positionActions } from '../../positionSlice/positionSlice';

const isNotRemovedConnection = (
    positionConnection: Connection,
    removedConnection: Connection
): boolean =>
    !(
        positionConnection.from === removedConnection.from &&
        positionConnection.to === removedConnection.to &&
        positionConnection.type === removedConnection.type
    );
export const removeConnection = createAsyncThunk<void, Connection, { state: RootState }>(
    'positionsConnections/removeConnection',
    async (removedConnection, { getState, dispatch }) => {
        const state = getState();

        const { connections: positionsConnections } = state.positionsConnectionsReducer;

        const updateConnections = positionsConnections.filter((positionsConnection) =>
            isNotRemovedConnection(positionsConnection, removedConnection)
        );

        const { guid: guidFrom, connections: connectionsFrom } =
            state.positionReducer.entities[removedConnection.from];
        const { guid: guidTo, connections: connectionsTo } =
            state.positionReducer.entities[removedConnection.to];

        const updateConnectionsFrom = connectionsFrom.filter((connection) =>
            isNotRemovedConnection(connection, removedConnection)
        );
        const updateConnectionsTo = connectionsTo.filter((connection) =>
            isNotRemovedConnection(connection, removedConnection)
        );

        dispatch(
            positionActions.updateMany([
                {
                    id: guidFrom,
                    changes: { connections: updateConnectionsFrom },
                },
                {
                    id: guidTo,
                    changes: { connections: updateConnectionsTo },
                },
            ])
        );

        dispatch(positionsConnectionsActions.setConnections(updateConnections));
    }
);
